jQuery(document).on("click", ".button-plus", function () {
  var productSizes = jQuery(this).parent().find('.product-sizes');
  productSizes.addClass('active');
});
jQuery(document).on("click", ".button-close", function () {
  var productSizes = jQuery(this).parent().removeClass('active');
});


document.addEventListener("DOMContentLoaded", () => {
	// Activate product sizes when the button is clicked
	document.querySelectorAll("button.button-plus").forEach((button) => {
		const wrapper = button.parentNode;
		button.addEventListener("click", () => {
			button.classList.add("hidden");

			const productSizes = wrapper.querySelector(".product-sizes");
			if (productSizes) {
				productSizes.classList.add("active");

				// Attach event listeners to deactivate product sizes when a variant is clicked
				productSizes.querySelectorAll("button.ProductItem__Variant").forEach((variant) => {
					variant.addEventListener("click", () => {
						productSizes.classList.remove("active");
						button.classList.remove("hidden");
					});
				});
			}
		});
	});

	// Close product sizes when the close button is clicked
	document.querySelectorAll("button.button-close").forEach((closeButton) => {
		closeButton.addEventListener("click", () => {
			const wrapper = closeButton.closest(".prductitem-quickadd");

			if (wrapper) {
				const productSizes = wrapper.querySelectorAll(".product-sizes");
				productSizes.forEach((el) => {
					el.classList.remove("active");
				});

				const plusButton = wrapper.querySelector("button.button-plus");
				if (plusButton) {
					plusButton.classList.remove("hidden");
				}
			}
		});
	});
});
